<template>
  <div>
    <!-- <page-header></page-header> -->
    <router-view class="overflow-y-auto" :style="scrollViewStyle"></router-view>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title word-type pb-0"
      ><icon-paid-holiday :width="24" :height="24" />주요휴가현황</v-col
      >
    </v-row>

    <v-simple-table class="px-6 mt-6 mb-2">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center">
              구분
            </th>
            <th class="text-center">
              이월시간
            </th>
            <th class="text-center">
              발생시간
            </th>
            <th class="text-center">
              사용시간
            </th>
            <th class="text-center">
              잔여시간
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(item, i) in listGnt"
              :key="i"
          >
            <td class="text-left">{{ item.gntNm }}</td>
            <td class="text-center">
              <v-list class="holiday_date_list">
                <v-list-item>
                  {{ item.frdCntTime }}H
                </v-list-item>
                <v-list-item class="small-text">
                  {{ item.tFrdCnt }}일{{ item.frdCntDayTime }}H
                </v-list-item>
              </v-list>
            </td>
            <td class="text-center">
              <v-list class="holiday_date_list">
                <v-list-item>
                  {{ item.creCntTime}}H
                </v-list-item>
                <v-list-item class="small-text">
                  {{ item.tCreCnt }}일{{ item.creCntDayTime}}H
                </v-list-item>
              </v-list>
            </td>
            <td class="text-center">
              <v-list class="holiday_date_list">
                <v-list-item>
                  {{ item.usedCntTime }}H
                </v-list-item>
                <v-list-item class="small-text">
                  {{ item.tUsedCnt}}일{{item.usedCntDayTime}}H
                </v-list-item>
              </v-list>
            </td>
            <td class="text-center">
              <v-list class="holiday_date_list">
                <v-list-item>
                  {{ item.restCntTime }}H
                </v-list-item>
                <v-list-item class="small-text">
                  {{ item.tRestCnt }}일{{item.restCntDayTime}}H
                </v-list-item>
              </v-list>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    <v-row class="add-desc">※ 잔여시간은 일 8시간 근무자 기준임.</v-row>
    <v-row class="add-desc">※ {{ String(new Date().getFullYear()).substring(2,4) }}년 연차휴가 촉진일수: 120H(15일)</v-row>

    <v-row class="title-wrap title-wrap d-flex flex-column mt-7 mt-7">
      <v-col class="d-flex detail-title"
      >신청내역
      </v-col>
      <v-col class="pa-0" >
        <v-list-item-group v-for="(item, i) in list"
          :key="i">
          <v-list-item
              class="detail-list"
              disabled
          >
            <v-list-item-content class="detail-list-content">
              <v-list-item-title>{{ item.gntNm }}</v-list-item-title>
              <v-list-item-subtitle>
                <span>{{ item.sYmd }}</span>
                <span class="vline">|</span>
                <span>{{ item.eYmd }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-col>
    </v-row>

    <empty-data v-if="emptyDataFlag" v-bind:text="emptyDataText"></empty-data>

    <v-bottom-navigation
        fixed
        scroll-threshold="500"
        height="96"
        v-show="this.$store.getters.GET_USER_DATA.ssnStatusCd!=='CA'"
    >
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
              block
              elevation="0"
              class="btn-fixed btn-green"
              @click="goVacationMenu"
          >
            <span class="white--text">근태/휴가신청</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>

  </div>
</template>
<script>
//import PageHeader from '@/components/common/PageHeader.vue';
import IconPaidHoliday from "@/assets/customIcon/IconPaidHoliday.vue";
import dayjs from 'dayjs';
import {
  getVacationMyHoliday,
  getVacationMyHolidayList,
} from '@/api/workStatus';
import routerConstants from '@/const/routerConstants';
import EmptyData from '@/components/common/EmptyData.vue';
import messageConstants from '@/const/messageConstants.js';

export default {
  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },
  data: () => ({
    listGnt: [],
    list: [],
    emptyDataFlag: false, // 조회결과없음 플래그
    emptyDataText: messageConstants.emptyDataMsg_1
  }),
  components: {
    //PageHeader,
    IconPaidHoliday,
    EmptyData,
  },

  methods: {
    async goVacationMenu() {
      const applParam = {
        applCd: '22',
        gntGubunCd: null,
      };

      await this.$store.dispatch(
            'ELA/FETCH_MENU_ACTION',
            applParam,
          );

      this.$router.push(routerConstants.VacationGntGubunMenuView);
    },
  },

  async mounted() {
      let params = {
        searchYear: dayjs().format('YYYY'),
      }

      let response = await getVacationMyHoliday(params);
      this.listGnt = response.data.data;

      response = await getVacationMyHolidayList(params);
      this.list = response.data.data;
      this.emptyDataFlag = this.list.length < 1;
    }
};


</script>

<style>
.v-main__wrap { padding-bottom: 96px; }
.v-data-table__wrapper { border-top: 1px solid #111; border-bottom: 1px solid #ccc;}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  word-break: keep-all;
  padding: 0 4px;
  background-color: #f5f5f5;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:first-child {
  word-break: break-all;
  padding: 0 4px !important;
  text-align:left;
  width: 65px;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  word-break: keep-all;
  padding: 4px !important;
  text-align:center;
  line-height: 1.4;
}
</style>
